<template>
  <el-container
    class="background-img">
    <div
      class="div-slogan">
      <div class="slogan">
        <h1>Tus boletos rápido, fácil y seguro.</h1>
      </div>
      <div class="search-home">
        <el-input
          v-model="mtSearch"
          placeholder="Buscar evento, artista o lugar"
          @keyup.enter.native="goToSearch(mtSearch)">
          <i
            slot="prefix"
            class="icon-search"/>
        </el-input>
      </div>
    </div>
    <nav-bar class="nav-bar"/>
  </el-container>
</template>

<script>
import navBar from '../navbar/navbar'
import header from '../header/header'
export default {
  name: 'Background',
  components: {
    navBar, header
  },
  data () {
    return {
      mtSearch: ''
    }
  },
  methods: {
    goToSearch (resSearch) {
      if (resSearch === '') {
        this.$router.push({name: 'Búsqueda'})
      }
      if (resSearch !== '') {
        this.$router.push({name: 'Búsqueda', query: {[`filters[where][name][contains]`]: resSearch}})
      }
    },
    searchFunction () {
    }
  }
}
</script>

<style lang="scss" scoped>

  .background-img{
    height: 100vh;
    background: url('/static/images/main-banner.jpg') center no-repeat;
    filter: brightness(0.9);
    background-size: cover;
    display: flex;
    align-items: center;
    position: relative;
    @media #{$NoteS}{
      height: 60vh !important;
      background-position: center 50px;
    }
    @media #{$iPhone}{
      height: 352px !important;
      background-position: center 50px;
    }
    @media #{$iPhoneLandscape} {
      height: 100vh;
      background-position: center 50px;
    }
    .div-slogan{
      @include center-vertically;
      width: 100%;
      .slogan{
        width: 100%;
        text-align: center;
        margin-bottom: 47px;
        @media #{$Note}{
          margin-bottom: 10px;
        }
        @media #{$Elementxs} {
          margin-bottom: 10px;
        }
        h1{
          @include font-primary(46px,light);
          color: white;
          margin: 0;
          @media #{$Elementxs} {
            @include font-primary(40px,light);
          }
          @media #{$iPhone} {
            @include font-primary(24px !important,light);
          }
          @media #{$iPhoneLandscape} {
            @include font-primary(30px,light);
          }
        }
      }
    }

  }

  .nav-bar{
    position: absolute;
    bottom: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/background/background.vue